<script>
import { EventBus } from '@/assets/js/helpers'
import Dropdown from '@oldShared/lasso/vue-components/Dropdown'
import IconButton from '@/components/IconButton.vue'

/** The help menu in the toolbar. Both items open the help desk (HelpDesk.vue). */
export default {
  data () {
    return {
      EventBus: EventBus,
      open: false,
    }
  },
  methods: {
    openHelpdesk (target) {
      this.$refs.hcDropdown.open = false
      EventBus.$emit('open-helpdesk', target)
    },
  },
  components: {
    Dropdown,
    IconButton,
  }
}
</script>

<template>
  <dropdown
    ref="hcDropdown"
    class="hc-dropdown"
    left
    :minWidth="220"
    :tabIndex="3"
    :EventBus="EventBus"
    @opened="open = true"
    @closed="open = false"
  >
    <div
      slot="toggle"
      class="d-flex align-items-center justify-content-center"
      style="width: 40px; height: 40px; position: relative;"
    >
      <IconButton
        :class="[
          'toolbar-icon-button',
          open && 'toolbar-icon-button--peach',
        ]"
        icon="message_question_outline_rounded_custom"
        size="normal"
        :buttonColor="open ? 'peach' : undefined"
        style="pointer-events: auto;"
      />
    </div>

    <div>
      <div
        class="dropdown-item d-flex align-items-center"
        @click="openHelpdesk('/contact')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          fill="#777"
          style="margin-right:12px"
        >
          <path
            d="M0 0h24v24H0V0z"
            fill="none"
          />
          <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
        </svg>
        Skriv til kundeservice
      </div>

      <div
        class="dropdown-item d-flex align-items-center"
        @click="openHelpdesk('/kb')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          fill="#777"
          style="margin-right:12px"
        >
          <path
            d="M0 0h24v24H0V0z"
            fill="none"
          />
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
        Søg i Hjælp til Lasso
      </div>
    </div>
  </dropdown>
</template>

<style lang="less">
.hc-dropdown {
  > span.toggle {
    cursor: default;
    pointer-events: none;
  }

  .menu {
    border-radius: 8px;

    &.left {
      right: -96px;
    }

    .toolbar-icon-button {
      &--open .md-icon {
        color: #FFA07A;
      }
    }

    @media only screen and (min-width: 768px) {
      &.left {
        right: 0;
        left: auto;
        margin-top: 9px;
      }
    }
  }
}
</style>
